import dotenv from '@root/.env.json'

export const isClient = (typeof window !== 'undefined')

export const isServer = (typeof window === 'undefined')

export function env(name) {
	if (name) return dotenv[name]
	return dotenv
}